/*
 * Copyright 2025 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-mobile/blob/master/LICENSE.md
 */
package org.mifos.mobile.feature.qr.qr

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import kotlinx.serialization.Serializable
import org.mifos.mobile.core.model.entity.beneficiary.Beneficiary
import org.mifos.mobile.core.model.enums.BeneficiaryState
import org.mifos.mobile.core.ui.composableWithPushTransitions

@Serializable
data object QrCodeReaderRoute

fun NavController.navigateToQrReaderScreen(navOptions: NavOptions? = null) {
    this.navigate(QrCodeReaderRoute, navOptions)
}

fun NavGraphBuilder.qrReaderDestination(
    navigateBack: () -> Unit,
    navigateToQrImportScreen: () -> Unit,
    openBeneficiaryApplication: (Beneficiary, BeneficiaryState) -> Unit,
) {
    composableWithPushTransitions<QrCodeReaderRoute> {
        QrCodeReaderScreen(
            navigateBack = navigateBack,
            openBeneficiaryApplication = openBeneficiaryApplication,
            navigateToQrImportScreen = navigateToQrImportScreen,
        )
    }
}
